import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface BpmTagProps {
  bpm?: number;
}

const BpmTag = ({ bpm }: BpmTagProps) => {
  const { t } = useTranslation();
  if (!bpm) return null;

  return <Chip label={`${bpm} ${t('tags:type:bpm')}`} variant="outlined" />;
};

export default BpmTag;
